import { FC } from 'react';
import { getBillReceiptSelector } from 'store/bill/selectors';
import { useAppSelector } from 'store/hooks';
import { SingleReceiptProviderItem } from 'components/Receipt/SingleReceiptItem';
import { ProviderAccordionGroup } from 'components/shared';
import { PROVIDER_TYPE } from 'utils/enums';
import { IBillReceipt } from 'utils/types';

export const SingleReceiptOuterProviders: FC = () => {
	const receipt: IBillReceipt = useAppSelector(getBillReceiptSelector);

	return (
		<>
			{!!receipt.data?.serviceProviderData[PROVIDER_TYPE.HEZ]?.length && (
				<ProviderAccordionGroup marginBottom="var(--spacing-3)">
					{receipt.data.serviceProviderData[PROVIDER_TYPE.HEZ].map((item, index) => (
						<SingleReceiptProviderItem key={`${item.id ?? item.code}-${index}`} serviceList={[item]} />
					))}
				</ProviderAccordionGroup>
			)}
			{!!receipt.data?.serviceProviderData[PROVIDER_TYPE.NAFTOGAS]?.length && (
				<ProviderAccordionGroup marginBottom="var(--spacing-3)">
					{receipt.data.serviceProviderData[PROVIDER_TYPE.NAFTOGAS].map((item, index) => (
						<SingleReceiptProviderItem key={`${item.id ?? item.code}-${index}`} serviceList={[item]} />
					))}
				</ProviderAccordionGroup>
			)}
		</>
	);
};
